import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import {
  CtBinaryOperator,
  CtModelConfiguration,
  CTModelDatatableFilter
} from "@ctsolution/ct-framework";
import { WorkOrderEventLogRouteData } from "../../../../../_core/route-data/work-order-event-log.route-data";
import { DEFAULT_DATATABLE_CONFIGURATION } from "../../../../../_core/constants";

/**
 * Componente modale per la visualizzazione dei log degli eventi di un WorkOrder
 * Utilizza il pattern ct-model con filtro sul WorkOrder.Oid corrente
 */
@Component({
  selector: 'app-work-order-event-log-dialog',
  template: `
      <!-- Header della modale -->
      <div class="dialog-log-container">
        <div>
      <div mat-dialog-title class="dialog-header">
        <h2>{{ 'LOG_EVENTI_COMMESSA' | translate }}</h2>
      </div>
      
      <!-- Contenuto della modale -->
      <div mat-dialog-content class="dialog-content">
        <!-- Visualizza la ct-model configurata per i log eventi -->
        <ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>
      </div>
      </div>
      <!-- Footer della modale -->
      <div mat-dialog-actions class="dialog-actions" style="justify-content: flex-end;">
        <button mat-raised-button 
                color="primary" 
                (click)="close()">
          {{ 'close' | translate }}
        </button>
      </div>
            </div>

  `,
  styleUrls: ['./work-order-event-log-dialog.component.scss']
})
export class WorkOrderEventLogDialogComponent implements OnInit {

  // Configurazione per il ct-model che mostrerà i log degli eventi
  configuration: CtModelConfiguration<WorkOrderEventLogDialogComponent> | null = null;

  constructor(
    private dialogRef: MatDialogRef<WorkOrderEventLogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkOrderEventLogDialogData
  ) { }

  ngOnInit(): void {
    this.setupConfiguration();
  }

  /**
   * Configura il ct-model con il controller WorkOrderEventLog
   * e applica il filtro sul WorkOrder.Oid corrente
   */
  private setupConfiguration(): void {
    // Verifica che ci sia un WorkOrder.Oid valido
    if (!this.data?.workOrderOid) {
      console.error('WorkOrder.Oid non fornito per la configurazione dei log eventi');
      return;
    }

    // Crea la configurazione del ct-model seguendo il pattern esistente
    const configuration = CtModelConfiguration
      .create<WorkOrderEventLogDialogComponent>()
      .setRouteData(WorkOrderEventLogRouteData())
      .setOperations([]) // Utilizza la route-data esistente
      .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION()); // Configurazione datatable standard

    // Applica il filtro per mostrare solo i log del WorkOrder corrente
    configuration
      .filterValues
      .addConstantFilter(
        CTModelDatatableFilter
          .create()
          .setField("WorkOrder.Oid") // Campo di filtro
          .setValue(this.data.workOrderOid) // Valore del WorkOrder.Oid corrente
          .setOperatorType(CtBinaryOperator.Equal) // Operatore di uguaglianza
      );

    configuration
      .initialized()
      .subscribe(() => configuration?.setOperations([]))

    this.configuration = configuration;
  }

  /**
   * Chiude la modale
   */
  close(): void {
    this.dialogRef.close();
  }
}

/**
 * Interfaccia per i dati passati alla modale
 */
export interface WorkOrderEventLogDialogData {
  /** OID del WorkOrder per il quale mostrare i log eventi */
  workOrderOid: number;
}
